import React from "react";

// Material UI components
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownSharpIcon from "@material-ui/icons/ArrowDropDownSharp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

// Local
import About from "../components/about";
import { LogoutMenuItem } from "../authentication/logout";
import Profile from "./profile";
import useStyles from "./styles";
import { menuItemIconMargin } from "../globalStyles";

const DrawerProfile: React.FC = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [aboutOpen, setAboutOpen] = React.useState<boolean>(false);

  const handleMenu = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <Button
        className={classes.drawerProfileButton}
        data-cy="menu-user-mobile"
        onClick={handleMenu}
        color="inherit"
        endIcon={<ArrowDropDownSharpIcon />}
        fullWidth
      >
        <Profile />
      </Button>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={!!anchorEl}
        onClose={handleClose}
        disablePortal={false}
        getContentAnchorEl={null}
        style={{ zIndex: 1400 }}
      >
        <MenuItem
          onClick={() => {
            setAboutOpen(true);
            handleClose();
          }}
        >
          <InfoOutlinedIcon style={menuItemIconMargin} />
          About
        </MenuItem>
        <LogoutMenuItem />
      </Menu>

      <About open={aboutOpen} close={() => setAboutOpen(false)} />
    </>
  );
};

export default DrawerProfile;
